import React, { type ReactNode } from "react";
import { useTimelineHorizontalSwiper } from "../hooks/use-timeline-horizontal-swiper";

interface IProps {
  children: ReactNode;
}

export const TimelineHorizontalMobile = ({ children }: IProps) => {
  useTimelineHorizontalSwiper();

  return (
    <div className="tw-relative tw-block tw-w-full tw-items-start tw-justify-start [overflow-x:clip] [overflow-y:visible]">
      <div className="swiper">
        <div className="swiper-wrapper">
          {React.Children.map(children, (child) => (
            <div className="swiper-slide">{child}</div>
          ))}
        </div>
      </div>
    </div>
  );
};
